import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const transform = {
    right: null,
    left: 'rotate(180deg)',
    top: 'rotate(-90deg)',
    bottom: 'rotate(90deg)',
};

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

const TicketStub = ({ color, className }) => (
    <svg
        className={classNames([
            {
                [className]: className !== null,
            },
        ])}
        id="a"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 34.84 62.18"
    >
        <path
            id="c"
            d="M13.81,31.09c0,8.58-6.18,15.54-13.81,15.54v15.54H34.84V0H0V15.54c7.63,0,13.81,6.96,13.81,15.54Z"
            fill={color}
        />
    </svg>
);

TicketStub.propTypes = propTypes;
TicketStub.defaultProps = defaultProps;

export default TicketStub;
